// extracted by mini-css-extract-plugin
export default {"buttons":"CompanyMisc_buttons__Vec-m"};